import React, { Fragment } from 'react'

export default function Wrapper({ children }) {
  return (
    <Fragment>
      { children }
    </Fragment>
  )
}
